// =====================================================================================
// MOCK DATA - Datos reales extraídos de la BD (crossover)
// =====================================================================================
// Fecha de extracción: 2025-11-15
// Fuente: postgresql://postgres:***@crossover.proxy.rlwy.net:27757/railway
// Tablas: contactos_dm, prospect_crm_data, support_agents
//
// IMPORTANTE: Estos datos son REALES pero usados como MOCK para desarrollo UI-first
// En Fase 2, se reemplazarán por llamadas API reales
// =====================================================================================

/**
 * AGENTES DEL SISTEMA
 * Fuente: support_agents table
 */
export const MOCK_AGENTS = [
  {
    id: 1,
    phone: '+56961208178',
    name: 'Daniel',
    avatar: 'https://ui-avatars.com/api/?name=Daniel&background=3b82f6&color=fff',
    status: 'online',
    color: '#3b82f6'
  },
  {
    id: 2,
    phone: '+56973332458',
    name: 'Eduardo',
    avatar: 'https://ui-avatars.com/api/?name=Eduardo&background=10b981&color=fff',
    status: 'online',
    color: '#10b981'
  },
  {
    id: 3,
    phone: '+56948096830',
    name: 'Giancarlo',
    avatar: 'https://ui-avatars.com/api/?name=Giancarlo&background=8b5cf6&color=fff',
    status: 'online',
    color: '#8b5cf6',
    isAdmin: true
  },
  {
    id: 4,
    phone: '+56994363503',
    name: 'Iván',
    avatar: 'https://ui-avatars.com/api/?name=Ivan&background=f59e0b&color=fff',
    status: 'offline',
    color: '#f59e0b'
  },
  {
    id: 5,
    phone: '+56992331052',
    name: 'Lisette',
    avatar: 'https://ui-avatars.com/api/?name=Lisette&background=ec4899&color=fff',
    status: 'online',
    color: '#ec4899'
  },
  {
    id: 6,
    phone: '+56950147643',
    name: 'Nicolás',
    avatar: 'https://ui-avatars.com/api/?name=Nicolas&background=06b6d4&color=fff',
    status: 'online',
    color: '#06b6d4'
  }
];

/**
 * CHATS / CONTACTOS
 * Fuente: contactos_dm + prospect_crm_data (LEFT JOIN)
 * Últimos 20 contactos ordenados por último mensaje
 */
export const MOCK_CHATS = [
  {
    id: 2140,
    phone: '+56973359086',
    name: 'Confecciones Egu',
    avatar: 'https://ui-avatars.com/api/?name=Confecciones+Egu&background=random',
    lastMessage: 'Que valores tienen',
    lastMessageTime: '2025-11-15T17:35:22.683716Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 3,
    isGroup: false
  },
  {
    id: 2139,
    phone: '+56985437800',
    name: 'Alvaro Ramirez',
    avatar: 'https://ui-avatars.com/api/?name=Alvaro+Ramirez&background=random',
    lastMessage: 'Valor?',
    lastMessageTime: '2025-11-15T15:13:08.806585Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 2,
    isGroup: false
  },
  {
    id: 1784,
    phone: '+56920657679',
    name: 'MAYORISTA MIRAGWAN SpA',
    avatar: 'https://ui-avatars.com/api/?name=MAYORISTA+MIRAGWAN&background=random',
    lastMessage: 'Hoy',
    lastMessageTime: '2025-11-15T14:31:20.07276Z',
    assignedTo: 'Nicolás',
    stage: 'bombilla_apagada',
    businessName: 'MAYORISTA MIRAGWAN SpA',
    priority: 0,
    unreadCount: 1,
    isGroup: false
  },
  {
    id: 2138,
    phone: '+56998958827',
    name: 'Dani Roa 🌻',
    avatar: 'https://ui-avatars.com/api/?name=Dani+Roa&background=random',
    lastMessage: 'Y cómo funciona y cuánto vale?',
    lastMessageTime: '2025-11-15T14:14:45.894359Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 1,
    isGroup: false
  },
  {
    id: 2137,
    phone: '+56978827054',
    name: 'Lucy',
    avatar: 'https://ui-avatars.com/api/?name=Lucy&background=random',
    lastMessage: 'Envia regiones y el valor, se puede pagar con tarjeta y cual seria el pie con debito',
    lastMessageTime: '2025-11-15T13:55:35.57824Z',
    assignedTo: 'Carlos Raggio',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2136,
    phone: '+56950685287',
    name: 'Nelson Segura',
    avatar: 'https://ui-avatars.com/api/?name=Nelson+Segura&background=random',
    lastMessage: 'Quiero saber más de la Boleta-electrónica de Club Almacén ?',
    lastMessageTime: '2025-11-15T01:27:53.332389Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 5,
    isGroup: false
  },
  {
    id: 2135,
    phone: '+56996355526',
    name: 'Alejandra Hernandez',
    avatar: 'https://ui-avatars.com/api/?name=Alejandra+Hernandez&background=random',
    lastMessage: 'Valores de los programas ??',
    lastMessageTime: '2025-11-15T00:16:58.315596Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 2,
    isGroup: false
  },
  {
    id: 2134,
    phone: '+56939076562',
    name: '+56939076562',
    avatar: 'https://ui-avatars.com/api/?name=56939076562&background=random',
    lastMessage: 'Quiero saber más del Software El Almacén ?',
    lastMessageTime: '2025-11-14T22:08:05.024387Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 1,
    isGroup: false
  },
  {
    id: 2132,
    phone: '+56920072141',
    name: 'Delicia Vidal',
    avatar: 'https://ui-avatars.com/api/?name=Delicia+Vidal&background=random',
    lastMessage: 'Hola',
    lastMessageTime: '2025-11-14T21:00:29.973018Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2133,
    phone: '+56958091837',
    name: 'Raquel Faúndez',
    avatar: 'https://ui-avatars.com/api/?name=Raquel+Faundez&background=random',
    lastMessage: 'Me gustaría que un Asesor me explique bien los Kits Digitaliza de Club Almacén ?',
    lastMessageTime: '2025-11-14T21:00:29.75906Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 1,
    isGroup: false
  },
  {
    id: 2131,
    phone: '+56935160994',
    name: '+56935160994',
    avatar: 'https://ui-avatars.com/api/?name=56935160994&background=random',
    lastMessage: 'Quiero saber más de los Kits POS Digitaliza de Club Almacén ?',
    lastMessageTime: '2025-11-14T20:10:11.821798Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2130,
    phone: '+56949115538',
    name: 'Lore',
    avatar: 'https://ui-avatars.com/api/?name=Lore&background=random',
    lastMessage: 'Precio',
    lastMessageTime: '2025-11-14T20:06:30.094129Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 1,
    isGroup: false
  },
  {
    id: 2129,
    phone: '+56976158757',
    name: '+56976158757',
    avatar: 'https://ui-avatars.com/api/?name=56976158757&background=random',
    lastMessage: 'Buenas tardes le comento actualmente tengo mercado pago y me gusta su sistema pero necesito tener mi inventario estos pueden ser compatibles?',
    lastMessageTime: '2025-11-14T19:58:50.55844Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 1,
    isGroup: false
  },
  {
    id: 2128,
    phone: '+56990760982',
    name: 'Daniel Chacón',
    avatar: 'https://ui-avatars.com/api/?name=Daniel+Chacon&background=random',
    lastMessage: 'Hola necesito un kit completo para un nuevo local de alementos y accesorios para mascotas',
    lastMessageTime: '2025-11-14T19:48:40.287644Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2126,
    phone: '+56926276991',
    name: 'Librería Los Profetitas',
    avatar: 'https://ui-avatars.com/api/?name=Libreria+Los+Profetitas&background=random',
    lastMessage: 'Dónde lo puedo comprar?',
    lastMessageTime: '2025-11-14T19:27:35.669477Z',
    assignedTo: 'Lisette',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2127,
    phone: '+56949748251',
    name: '+56949748251',
    avatar: 'https://ui-avatars.com/api/?name=56949748251&background=random',
    lastMessage: 'Hola',
    lastMessageTime: '2025-11-14T19:24:27.513207Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2108,
    phone: '+56974818389',
    name: 'Nilsa Calfuqueo',
    avatar: 'https://ui-avatars.com/api/?name=Nilsa+Calfuqueo&background=random',
    lastMessage: 'Se pueden realizar factura electrónica en el mismo pos',
    lastMessageTime: '2025-11-14T18:28:36.727915Z',
    assignedTo: 'Javier / RESPONDIDOS',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2125,
    phone: '+56968224637',
    name: '+56968224637',
    avatar: 'https://ui-avatars.com/api/?name=56968224637&background=random',
    lastMessage: 'Quiero saber más de los Kits POS Digitaliza de Club Almacén ?',
    lastMessageTime: '2025-11-14T18:07:48.438003Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 1,
    isGroup: false
  },
  {
    id: 2124,
    phone: '+56967503996',
    name: 'Bruno',
    avatar: 'https://ui-avatars.com/api/?name=Bruno&background=random',
    lastMessage: 'Quería cotizar un kit',
    lastMessageTime: '2025-11-14T18:00:37.290644Z',
    assignedTo: 'Ninguno',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  },
  {
    id: 2103,
    phone: '+56957830866',
    name: 'Me Amo Y Me Respeto AHORA',
    avatar: 'https://ui-avatars.com/api/?name=Me+Amo&background=random',
    lastMessage: 'Supermercado',
    lastMessageTime: '2025-11-14T16:56:57.513359Z',
    assignedTo: 'NO RESPONDEN',
    stage: null,
    businessName: null,
    priority: null,
    unreadCount: 0,
    isGroup: false
  }
];

/**
 * MENSAJES DE CONVERSACIÓN (MOCK para chat seleccionado)
 * Estos son ejemplos ficticios pero basados en patrones reales
 */
export const MOCK_MESSAGES = {
  2140: [ // Confecciones Egu
    {
      id: 1,
      type: 'incoming',
      text: 'Hola buenos días',
      timestamp: '2025-11-15T09:30:00Z',
      from: '+56973359086',
      status: 'read'
    },
    {
      id: 2,
      type: 'outgoing',
      text: 'Hola! 👋 Gracias por contactarnos. Te comento sobre nuestros kits...',
      timestamp: '2025-11-15T09:32:15Z',
      from: 'agent',
      status: 'read'
    },
    {
      id: 3,
      type: 'incoming',
      text: 'Que valores tienen',
      timestamp: '2025-11-15T17:35:22Z',
      from: '+56973359086',
      status: 'delivered'
    }
  ],
  2139: [ // Alvaro Ramirez
    {
      id: 1,
      type: 'incoming',
      text: 'Valor?',
      timestamp: '2025-11-15T15:13:08Z',
      from: '+56985437800',
      status: 'read'
    }
  ]
};

/**
 * DATOS DE PROSPECTO (MOCK completo)
 * Ejemplo de prospecto con todos los campos
 */
export const MOCK_PROSPECT_DATA = {
  2140: { // Confecciones Egu
    // Datos personales
    nombre: 'Confecciones',
    apellido: 'Egu',
    telefono: '+56973359086',
    email: 'contacto@confeccionesegu.cl',
    mensajeInicial: 'Hola buenos días',

    // Negocio
    productosInteres: ['Kit Básico', 'Boletas Electrónicas'],
    tipoNegocio: 'Confecciones',
    comuna: 'Santiago Centro',
    modeloFuncionamiento: 'Retail con producción propia',

    // Proceso de venta
    plazoDecision: 'Esta semana',
    presupuesto: 150000,
    horario1Llamadas: '9:00-12:00',
    horario2Llamadas: '15:00-18:00',

    // Pain points
    problema1: 'Control de inventario de telas',
    problema2: 'Boletas electrónicas para clientes mayoristas',

    // Botones rojos (deal breakers)
    botonRojo1: 'Instalación en 48 horas',
    botonRojo2: 'Capacitación incluida',
    botonRojo3: 'Soporte técnico local',

    // Metadatos
    fechaCreacion: '2025-11-15T09:30:00Z',
    fechaUltimaModificacion: '2025-11-15T17:35:00Z',
    fechaVencimiento: '2025-11-22',
    ultimaModificacionPor: '+56948096830', // Giancarlo

    // Stage
    stage: 'bombilla_prendida',
    priority: 2
  },
  1784: { // MAYORISTA MIRAGWAN SpA
    nombre: 'MAYORISTA MIRAGWAN',
    apellido: 'SpA',
    telefono: '+56920657679',
    email: 'ventas@miragwan.cl',
    mensajeInicial: 'Buenos días, necesito información',
    productosInteres: ['Kit Premium', 'Sistema de Inventario'],
    tipoNegocio: 'Distribuidora mayorista',
    comuna: 'Maipú',
    modeloFuncionamiento: 'Venta al por mayor',
    plazoDecision: 'Este mes',
    presupuesto: 500000,
    horario1Llamadas: '10:00-13:00',
    horario2Llamadas: '14:00-17:00',
    problema1: 'Sistema antiguo muy lento',
    problema2: 'No tiene integración con proveedores',
    botonRojo1: 'Migración de datos sin pérdidas',
    botonRojo2: 'Integración con ERPs existentes',
    botonRojo3: 'Garantía de uptime 99.9%',
    fechaCreacion: '2025-10-15T08:00:00Z',
    fechaUltimaModificacion: '2025-11-15T14:31:00Z',
    fechaVencimiento: '2025-11-30',
    ultimaModificacionPor: '+56950147643', // Nicolás
    stage: 'bombilla_apagada',
    priority: 0
  }
};

/**
 * FILTROS DISPONIBLES
 */
export const MOCK_FILTERS = {
  stages: [
    { value: 'all', label: 'Todos', count: 138, color: '#6b7280' },
    { value: 'bombilla_apagada', label: 'Sin interés', count: 45, color: '#ef4444', icon: '💡' },
    { value: 'bombilla_prendida', label: 'Interesado', count: 32, count: '#f59e0b', icon: '💡' },
    { value: 'diamante', label: 'Calificado', count: 18, color: '#3b82f6', icon: '💎' },
    { value: 'torta', label: 'Negociación', count: 12, color: '#8b5cf6', icon: '🎂' },
    { value: 'pelota', label: 'Cierre', count: 8, color: '#10b981', icon: '⚽' },
    { value: 'billete', label: 'Venta', count: 23, color: '#059669', icon: '💵' }
  ],

  status: [
    { value: 'all', label: 'Todo', count: 138 },
    { value: 'pending', label: 'Pendiente', count: 11 },
    { value: 'in_progress', label: 'En proceso', count: 42 },
    { value: 'qualified', label: 'Calificado', count: 18 },
    { value: 'no_answer', label: 'Sin responder', count: 38 },
    { value: 'waiting', label: 'Espera más larga', count: 26 }
  ],

  agents: [
    { value: 'all', label: 'Todos', count: 138 },
    { value: '+56961208178', label: 'Daniel', count: 23 },
    { value: '+56973332458', label: 'Eduardo', count: 19 },
    { value: '+56948096830', label: 'Giancarlo', count: 15 },
    { value: '+56994363503', label: 'Iván', count: 12 },
    { value: '+56992331052', label: 'Lisette', count: 18 },
    { value: '+56950147643', label: 'Nicolás', count: 21 },
    { value: 'unassigned', label: 'Sin asignar', count: 30 }
  ],

  budget: [
    { value: 'all', label: 'Todos' },
    { value: 'low', label: 'Bajo (< $50.000)', min: 0, max: 50000 },
    { value: 'medium', label: 'Medio ($50.000 - $200.000)', min: 50000, max: 200000 },
    { value: 'high', label: 'Alto (> $200.000)', min: 200000, max: 999999999 }
  ],

  deadline: [
    { value: 'all', label: 'Todos' },
    { value: 'today', label: 'Hoy' },
    { value: 'this_week', label: 'Esta semana' },
    { value: 'this_month', label: 'Este mes' },
    { value: 'overdue', label: 'Vencidos' }
  ],

  comunas: [
    { value: 'all', label: 'Todas' },
    { value: 'Santiago Centro', label: 'Santiago Centro' },
    { value: 'Las Condes', label: 'Las Condes' },
    { value: 'Providencia', label: 'Providencia' },
    { value: 'Maipú', label: 'Maipú' },
    { value: 'La Florida', label: 'La Florida' },
    { value: 'Puente Alto', label: 'Puente Alto' },
    { value: 'Ñuñoa', label: 'Ñuñoa' }
  ]
};

/**
 * ESTADÍSTICAS DE DASHBOARD
 */
export const MOCK_STATS = {
  totalChats: 138,
  pending: 11,
  inProgress: 42,
  qualified: 18,
  unread: 38,
  todayMessages: 156,
  conversionRate: 23.5,
  avgResponseTime: '12 min'
};

/**
 * HELPER: Filtrar chats según criterios
 * @param {Object} filters - Objeto con filtros aplicados
 * @returns {Array} Chats filtrados
 */
export function filterChats(filters = {}) {
  let filtered = [...MOCK_CHATS];

  // Filtro por búsqueda
  if (filters.search) {
    const search = filters.search.toLowerCase();
    filtered = filtered.filter(chat =>
      chat.name.toLowerCase().includes(search) ||
      chat.phone.includes(search) ||
      chat.lastMessage.toLowerCase().includes(search)
    );
  }

  // Filtro por stage
  if (filters.stage && filters.stage !== 'all') {
    filtered = filtered.filter(chat => chat.stage === filters.stage);
  }

  // Filtro por agente
  if (filters.agent && filters.agent !== 'all') {
    if (filters.agent === 'unassigned') {
      filtered = filtered.filter(chat =>
        chat.assignedTo === 'Ninguno' || !chat.assignedTo
      );
    } else {
      const agent = MOCK_AGENTS.find(a => a.phone === filters.agent);
      if (agent) {
        filtered = filtered.filter(chat => chat.assignedTo === agent.name);
      }
    }
  }

  // Filtro por mensajes sin leer
  if (filters.onlyUnread) {
    filtered = filtered.filter(chat => chat.unreadCount > 0);
  }

  return filtered;
}

/**
 * HELPER: Obtener mensajes de un chat
 * @param {number} chatId - ID del chat
 * @returns {Array} Mensajes del chat
 */
export function getMessages(chatId) {
  return MOCK_MESSAGES[chatId] || [];
}

/**
 * HELPER: Obtener datos de prospecto
 * @param {number} chatId - ID del chat
 * @returns {Object} Datos del prospecto
 */
export function getProspectData(chatId) {
  return MOCK_PROSPECT_DATA[chatId] || null;
}

/**
 * HELPER: Formatear timestamp relativo ("hace 5 min", "hace 2h")
 * @param {string} timestamp - ISO timestamp
 * @returns {string} Tiempo relativo
 */
export function formatRelativeTime(timestamp) {
  const now = new Date();
  const past = new Date(timestamp);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'ahora';
  if (diffMins < 60) return `hace ${diffMins} min`;
  if (diffHours < 24) return `hace ${diffHours}h`;
  if (diffDays === 1) return 'ayer';
  if (diffDays < 7) return `hace ${diffDays} días`;

  return past.toLocaleDateString('es-CL');
}

export default {
  MOCK_AGENTS,
  MOCK_CHATS,
  MOCK_MESSAGES,
  MOCK_PROSPECT_DATA,
  MOCK_FILTERS,
  MOCK_STATS,
  filterChats,
  getMessages,
  getProspectData,
  formatRelativeTime
};
